import React, { type FunctionComponent } from 'react'
import { Formik } from 'formik'
import { GeneratedReportsAddForm } from 'legacy/sections/generated-reports/components/add/components/form/GeneratedReportsAddForm'
import { type UseGeneratedReportsAddBehaviour } from 'legacy/sections/generated-reports/components/add/utils/generatedReportsAdd.hooks'
import {
  useGeneratedReportsValidate,
  useGeneratedReportsOnSubmit,
} from 'legacy/sections/generated-reports/components/add/components/form/utils/generatedReportsAddForm.hooks'
import { type GeneratedReportsAddFormValues } from 'legacy/sections/generated-reports/components/add/components/form/utils/generatedReportsAddForm.types'

interface Props extends Pick<UseGeneratedReportsAddBehaviour, 'datasetOptions' | 'filterOptions'> {}

export const GeneratedReportsAddFormWrapper: FunctionComponent<Props> = ({
  datasetOptions,
  filterOptions,
}) => {
  const validate = useGeneratedReportsValidate(filterOptions)
  const onSubmit = useGeneratedReportsOnSubmit()
  const initialValues: GeneratedReportsAddFormValues = {
    reportName: '',
    reportType: '',
  }

  return (
    <Formik
      validateOnMount
      validateOnBlur
      initialValues={initialValues}
      validate={validate}
      onSubmit={onSubmit}
    >
      {props => (
        <GeneratedReportsAddForm
          datasetOptions={datasetOptions}
          filterOptions={filterOptions}
          {...props}
        />
      )}
    </Formik>
  )
}
